import {reactive, toRefs} from "vue";
import extensionIconJSON from './extension-icon.json'
import mime from "mime-types";
import Utilities from "fallco-frontend-framework/src/js/libs/utilities/index.js";

export default function useFileUploader(props, emits) {
  const data = reactive({
    fileTemplate: {
      bozza: null,
      data_caricamento: null,
      document_id: null,
      extensionIcon: null,
      is_accettato: null,
      is_blocked: null,
      message: null,
      name: null,
      note: null,
      sizeFormatted: '0',
      type: null,
      validate: false,
      validazione_notaio_at: null
    },
    extensionFileAccepted: null,
    maxSizeAccepted: null,
    unitsSize: ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    message: {
      errors: {
        general: 'Errore: ',
        extension: 'Estensione Non Valida',
        maxSize: 'Il file supera la dimensione massima'
      },
      success: {
        general: 'File Caricato Correttamente'
      }
    },
    extensionIcon: extensionIconJSON,
    fileOBJ: [],
    fileObjRejected: []
  })

  /**
   * Converte la size del file in un formato leggibile
   * @param fileSize
   * @returns {string}
   * @private
   */
  function convertByteInReadableFormat(fileSize) {
    if (fileSize > 0) {
      const i = parseInt(Math.floor(Math.log(fileSize) / Math.log(1024)).toString())
      return `${(fileSize / Math.pow(1024, i)).toFixed(1)} ${data.unitsSize[i]}`;
    }

    return '0';
  }

  /**
   * Compone Oggetto da utilizzare per la visualizzazione del File Caricato con le proprietà necessarie
   * @param file
   * @returns {{}}
   */
  function addObjectProperties(file) {
    let fileObj = {
      error: null,
      sizeFormatted: null,
      nome_file: null,
      type: null,
      extensionIcon: null,
      documento_id: null,
      data_caricamento: null,
      message: null,
      validate: false,
      is_blocked: null,
      is_accettato: null,
      bozza: null,
      note: null,
      validazione_notaio_at: null,
      filesystem_name: null,
      aggiunto_da_utente: null,
      caricato_da: null
    };

    Object.keys(fileObj).forEach(function(fileKey) {
      if(file[fileKey] !== null) {
        fileObj[fileKey] = file[fileKey];
      }
    });

    if(!file['sizeFormatted']) {
      fileObj['sizeFormatted'] = convertByteInReadableFormat(file.size);
    }

    if(!file['type']) {
      fileObj.type = (fileObj.name) ? fileObj.name.split('.').pop() : '';
    }

    let fileType = (file.type) ? file.type : (fileObj.name) ? (fileObj.name).split('.').pop() : 'jpg';

    if(!file['extensionIcon']) {
      fileObj.extensionIcon = data.extensionIcon['.' + fileType];
    }

    fileObj.documento_id = file.documento_id ? file.documento_id : file.file_id;

    if(!file['data_caricamento']) {
      fileObj.data_caricamento = file.created_at != null ? file.created_at : (file.insert_timestamp) ? file.insert_timestamp : (file.caricato_il) ? file.caricato_il : null;
    }

    if(!file['nome_file']) {
      fileObj.nome_file = file.name;
    }

    if(!file['validate'] && file['file_id']) {
      fileObj.validate = true;
    }


    return fileObj;
  }

  /**
   * Cicla tutti i files precedentemente caricati e formatta gli oggetti con le proprietà necessarie
   * @param file
   * @returns {*[]}
   */
  function composeFileObject(files) {
    if (files === {} || files === [] || !files) {
      return;
    }

    let fileObj = {};
    let filesArray = [];

    if (Array.isArray(files)) {
      files.forEach((file) => {
        fileObj = addObjectProperties(file)
        filesArray.push(fileObj)
      })
    } else {
      if (files && Object.keys(files).length > 0) {
        filesArray = addObjectProperties(files)
      }
    }

    return filesArray;
  }


  /**
   * Controlla se il file è considerato valido
   * Attuali parametri di controllo possibili:
   * - estensione
   * - max size (beta)
   * @param file
   * @returns {*}
   * @private
   */
  function _validateFile(file) {
    let extensionIsValid = true;
    let maxFileSizeIsValid = true;

    // Questo controllo si è reso necessario perchè la dipendenza che usiamo per la trasformazione dei mime per il formato p7m usa due diciture pkcs7-mime e pkcs7-signature
    let fileType = file.type === 'application/pkcs7' ? 'application/pkcs7-mime' : file.type;
    if (data.extensionFileAccepted && !(data.extensionFileAccepted).includes(mime.extension(fileType))) {
      extensionIsValid = false;
    }

    if (extensionIsValid && maxFileSizeIsValid) {
      file.validate = true;
      file.message = null
      return file;
    }

    file.validate = false;
    file.message = data.message.errors.general + ' ';
    file.message += (!extensionIsValid) ? data.message.errors.extension : '';
    file.message += (!maxFileSizeIsValid) ? data.message.errors.maxSize : '';
    return file;
  }

  /**
   * Metodo utilizzato per validare il file caricato
   * @param file
   * @param options
   * @param additionalData
   * @param filesUploaded
   * @param filesRejected
   * @returns {{rejected: [], accepted: []}|boolean}
   */
  function processFile(file, options, additionalData, filesUploaded, filesRejected) {
    file.sizeFormatted = file.sizeFormatted ? file.sizeFormatted : convertByteInReadableFormat(file.size);
    file.extensionIcon = data.extensionIcon['.' + mime.extension(file.type)];
    data.fileOBJ = (filesUploaded) ? filesUploaded : [];
    data.fileOBJ = (typeof data.fileOBJ == 'object' && Object.keys(data.fileOBJ).length > 0) ? data.fileOBJ : [];
    data.fileOBJRejected = filesRejected ? filesRejected : [];
    data.extensionFileAccepted = options.extensionAccepted;
    data.maxSizeAccepted = options.maxSizeAccepted;
    options.maxFileNumber = (options.maxFileNumber == 0) ? null : options.maxFileNumber;
    file = _validateFile(file);
    if (!file.validate) {
      return {status: false, file: file};
    }

    return {status: true, file: file};
  }

  /**
   * Crea un FormData dei files prima del post effettivo
   * @param file
   * @param additionalData
   * @returns {FormData | FormData}
   */
  function composeFileToUpload(file, additionalData) {
    const randomID = Utilities.generate_random_id();
    let formData = new FormData();
    formData.append(`${randomID}[]`, file)
    Object.keys(additionalData).forEach(prop => {
      formData.append(`file_upload[${randomID}][${prop}]`, additionalData[prop])
    })
    formData.append('questionario_id', additionalData.questionario_id)

    return formData;
  }

  return {
    ...toRefs(data),
    addObjectProperties,
    composeFileObject,
    composeFileToUpload,
    processFile,
    convertByteInReadableFormat
  }
}